import { Component } from 'react'

import * as h from 'h'

import styles from './styles-animatedlincuslogo.scss'

export default class AnimatedLincusLogo extends Component {
  render () {
    return h.div(h.ca(styles.container),
      h.div(h.ca(styles.smallerNodesContainer),
        h.div(h.ca(styles.firstNodeAndEdge),
          h.div(h.ca(styles.smallerNode)),
          h.div(h.ca(styles.edge))),
        h.div(h.ca(styles.secondNodeAndEdge),
          h.div(h.ca(styles.smallerNode)),
          h.div(h.ca(styles.edge))),
        h.div(h.ca(styles.thirdNodeAndEdge),
          h.div(h.ca(styles.smallerNode)),
          h.div(h.ca(styles.edge)))),
      h.div(h.ca(styles.largeNode))
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Search/AnimatedLincusLogo.js